import styled from 'styled-components';
import CustomButton from '../button/CustomButton';

export const BtnDefault = styled(CustomButton)`
  padding: ${({ size }) =>
    size === 'small'
      ? '6px 14px'
      : size === 'xsmall'
      ? '8px 16px'
      : '8px 14px'};
  height: ${({ size }) => (size === 'small' ? 'fit-content' : '48px')};
  border-radius: ${({ size, borderRadius }) =>
    borderRadius ?? (size === 'xsmall' || size === 'small' ? '4px' : '8px')};
  font-size: ${({ fontSize, size }) =>
    fontSize ??
    (size === 'small' ? '14px' : size === 'xsmall' ? '12px' : '18px')};
  color: ${({ theme }) => theme.white};
  font-weight: 500;
  line-height: ${({ size }) => (size === 'small' ? 'normal' : 'unset')};
  background-color: ${({ color, theme }) =>
    theme[color] ?? color ?? theme.mainPrimary};
  border-color: ${({ color, theme }) =>
    theme[color] ?? color ?? theme.mainPrimary};
  &:hover,
  &:focus,
  &:active {
    border-color: ${({ color, theme }) =>
      theme[color] ?? color ?? theme.mainPrimary} !important;
    background-color: ${({ color, theme }) =>
      theme[color] ?? color ?? theme.mainPrimary} !important;
  }
  &:disabled {
    border-color: ${({ color, theme }) =>
      theme[color] ?? color ?? theme.mainPrimary}e6 !important;
    background-color: ${({ color, theme }) =>
      theme[color] ?? color ?? theme.mainPrimary}e6 !important;
  }
`;
export const BtnLink = styled(CustomButton)`
  padding: ${({ size }) =>
    size === 'small'
      ? '6px 14px'
      : size === 'xsmall'
      ? '8px 16px'
      : '8px 14px'};
  height: ${({ size }) => (size === 'small' ? 'fit-content' : '48px')};
  border-radius: ${({ size }) => (size === 'xsmall' ? '6px' : '8px')};
  font-size: ${({ fontSize, size }) =>
    fontSize ??
    (size === 'small' ? '14px' : size === 'xsmall' ? '12px' : '18px')};
  color: ${({ theme, color }) => color ?? theme.mainPrimary};
  font-weight: 500;
  border-color: transparent;
  background-color: transparent;
  &:hover,
  &:focus,
  &:active {
    color: ${({ theme, color }) => color ?? theme.mainPrimary} !important;
    border-color: transparent !important;
    background-color: transparent !important;
  }
`;

export const BtnOutlineDefault = styled(CustomButton)`
  background-color: transparent;
  border: ${({ size }) => (size === 'xsmall' ? '1px' : '2px')} solid
    ${({ color }) => color};
  color: ${({ color, theme }) => color ?? theme.primary};
  padding: ${({ size }) =>
    size === 'small'
      ? '6px 14px'
      : size === 'xsmall'
      ? '8px 16px'
      : '8px 14px'};
  height: ${({ size }) => (size === 'small' ? 'fit-content' : '48px')};
  font-weight: 500;
  border-radius: ${({ size }) => (size === 'xsmall' ? '6px' : '8px')};
  font-size: ${({ fontSize, size }) =>
    fontSize ??
    (size === 'small' ? '14px' : size === 'xsmall' ? '12px' : '18px')};
  &:hover,
  &:focus,
  &:active {
    background-color: transparent !important;
    border-color: ${({ color, theme }) => color ?? theme.primary} !important;
    color: ${({ color, theme }) => color ?? theme.primary} !important;
  }
  &:disabled {
    background-color: transparent;
    border-color: ${({ theme }) => theme.primaryLight};
    color: ${({ theme }) => theme.primaryLight};
  }
`;

export const Button = ({ variant, children, ...props }) => {
  switch (variant) {
    case 'outlined':
      return <BtnOutlineDefault {...props}>{children}</BtnOutlineDefault>;
    case 'link':
      return <BtnLink {...props}>{children}</BtnLink>;
    case 'default':
    default:
      return <BtnDefault {...props}>{children}</BtnDefault>;
  }
};

export const StyledCustomButton = {
  BtnDefault,
  BtnLink,
  BtnOutlineDefault,
  Button,
};
